import Loadable from '@/common/presentation/components/utils/Loader/Loadable';
import RouteErrorElement from '@/common/presentation/components/utils/RouteErrorElement';
import { lazy } from 'react';

const DeepLinkPage = Loadable(lazy(() => import('../presentation/pages/DeepLinkPage')));

const DeepLinkRoutes = {
  errorElement: <RouteErrorElement />,
  children: [
    {
      path: 'dl/appId/:appId/*',
      element: <DeepLinkPage />,
    },
    {
      path: 'dl/appId/:appId',
      element: <DeepLinkPage />,
    },
  ],
};

export default DeepLinkRoutes;
